module.exports = __webpack_public_path__ + "img/test_10.e7a9e646.png";